import React, { KeyboardEvent } from 'react';
import { useChatWidgetContext } from '../../ChatWidgetContext';
import ContextChipList from './ContextChipList';
import StopGenerationButton from './StopGenerationButton';
import styles from '../ChatWidget.module.scss';

export default function MessageInput() {
  const {
    sendMessage,
    stopGeneration,
    isStreaming,
    inputText,
    setInputText,
    selectedContext,
    removeContext,
  } = useChatWidgetContext();

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Escape' && isStreaming) {
      e.preventDefault();
      stopGeneration();
    } else if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  return (
    <div className={styles.inputArea}>
      <div className={styles.inputContainer}>
        <input
          type="text"
          className={styles.inputField}
          placeholder="Ask anything..."
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={isStreaming}
          data-testid="chat-message-input"
        />
        <StopGenerationButton variant="text" />
        {!isStreaming && (
          <button
            type="button"
            className={styles.sendButton}
            onClick={sendMessage}
            disabled={!inputText.trim()}
            data-testid="chat-send-button"
          >
            SEND &#9654;
          </button>
        )}
      </div>
      {selectedContext.length > 0 && (
        <div className={styles.inputContextArea}>
          <ContextChipList context={selectedContext} onRemove={removeContext} />
        </div>
      )}
    </div>
  );
}
